import React from 'react';

const AboutUs = () => {
    return (

        <div className='lg:px-24 md:px-4 px-2 py-28 mt-12 dark:bg-[#090833] dark:text-white movie'>
            <div className="mb-3">
                <h2 className='text-[18px] text-left text-[#e6e101]'>About Us</h2>
                <p>Welcome to [Your Movie Website Name]! We are passionate about movies and want to share our love of cinema with you. Our website is dedicated to providing you with the latest movie news, reviews, trailers, and more.
                    <br /><br />

                    Our team of movie enthusiasts is made up of [insert number of team members] members, each with a unique background and perspective on movies. We come from different parts of the world and have diverse tastes in movies, but we all share a common love for the magic of cinema.</p>
            </div>

            <div className="mb-3">
                <h2 className='text-[18px] text-left text-[#e6e101]'>Our Mission</h2>
                <p>Our mission is to be the go-to destination for movie lovers everywhere. We strive to provide the most comprehensive and up-to-date information about movies, from the latest releases to the classics. We want to create a community of movie enthusiasts who can come together to discuss, debate, and celebrate all things cinema.</p>
            </div>

            <div className="mb-3">
                <h2 className='text-[18px] text-left text-[#e6e101]'>Our Commitment to Quality</h2>
                <p>We are committed to providing the highest quality content to our readers. We take pride in our work and strive to ensure that every piece of content we publish is informative, engaging, and accurate. We welcome feedback from our readers and are always looking for ways to improve.
                    <br /><br />

                    Thank you for visiting [Your Movie Website Name]! We hope you enjoy our content and become a part of our movie-loving community. If you have any questions or comments, please don't hesitate to contact us.</p>
            </div>
        </div>
    );
};

export default AboutUs;